module.exports = __webpack_public_path__ + "static/media/olivia.6e4c86c1.png";